<template>
  <div class="new-page-con">
    <div class="layout_header">
      <Header> </Header>
    </div>
    <div class="dataServices-page customizePlan-container">
      <!-- 填写问卷 -->
      <div class="customizePlan-content" v-if="resultShow == 0">
        <div class="customizePlan-title">Customize Your Own Plan</div>
        <div class="customizePlan-subtitle">
          By answering the following questions, the system will recommend the
          optimal interface for you
        </div>
        <div class="customizePlan-questions">
          <div class="customizePlan-questions-steps">
            <ul class="questions-steps-ul flex_center" v-if="currentPage > 0">
              <li
                v-for="pageNum in totalPages"
                :key="'pageNum' + pageNum"
                :class="{ current: currentPage >= pageNum }"
                @click="goToPage(pageNum)"
              ></li>
            </ul>
          </div>
          <div class="customizePlan-questions-body">
            <!-- 接入数据 -->
            <div class="customizePlan-questions-page">
              <div
                class="customizePlan-questions-item"
                v-for="(item, index) in currentQuestions"
                :key="'question' + index"
              >
                <div class="customizePlan-questions-item-label">
                  <span
                    style="color: red"
                    v-if="item.customizePlanQuestion.otherDemand != 1"
                    >*</span
                  >
                  <!-- 显示必填星号 -->
                  {{ item.customizePlanQuestion.questionEn }}
                </div>
                <div class="customizePlan-questions-item-value">
                  <!-- 输入框 -->
                  <el-input
                    :key="item.customizePlanQuestion.id"
                    v-if="
                      item.customizePlanQuestion.keyMatch == 1 ||
                      item.customizePlanQuestion.otherDemand == 1
                    "
                    :type="
                      item.customizePlanQuestion.otherDemand == 1
                        ? 'textarea'
                        : ''
                    "
                    v-model="item.customizePlanQuestion.customerInput"
                    clearable
                    :placeholder="
                      item.customizePlanQuestion.questionDescriptionEn
                    "
                  ></el-input>
                  <!-- 下拉框 -->
                  <el-select
                    v-else
                    :key="item.customizePlanQuestion.id"
                    v-model="
                      selectedValueMap[item.customizePlanQuestion.questionEn]
                    "
                    clearable
                    filterable
                    :multiple="isMultiple(item)"
                    :multiple-limit="item.customizePlanQuestion.oneSelect || 0"
                    :placeholder="
                      item.customizePlanQuestion.questionDescriptionEn
                    "
                    @change="(val) => handleSelectChange(item, val)"
                  >
                    <el-option
                      v-for="(option, optIndex) in item.customizePlanAnswers"
                      :key="optIndex"
                      :label="option.answerEn"
                      :value="option.answerEn"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="customizePlan-questions-footer flex_center">
            <!-- <el-button
              type="primary" 
              class="customizePlan-questions-btn"
              @click="nextPage"
              v-if="currentPage == 0"
              key="begin"
              >Let's Begin</el-button
            >
            <template v-else> -->
            <el-button
              :disabled="!isCurrentPageValid"
              type="primary"
              class="customizePlan-questions-btn"
              @click="submit"
              v-if="currentPage >= totalPages"
              key="submit"
              >Show Result</el-button
            >
            <el-button
              :disabled="!isCurrentPageValid"
              type="primary"
              class="customizePlan-questions-btn"
              @click="nextPage"
              v-else
              key="next"
              >NEXT</el-button
            >
            <!-- </template> -->
          </div>
        </div>
      </div>
      <!-- 结果 -->
      <div class="customizePlan-content result" v-if="resultShow == 1">
        <div class="customizePlan-title">Recommended Services</div>
        <div class="customizePlan-subtitle">
          We recommend the following services for you.
        </div>
        <!-- 根据返回结果显示多个card -->
        <div class="customizePlan-result-card-list">
          <div
            class="customizePlan-result-card"
            v-for="score in resultShowData"
            :key="score.displayType"
            :class="{
              dataApiBg: score.displayType == 'api',
              dataBulkBg: score.displayType == 'bulkData',
            }"
          >
            <div
              class="customizePlan-result-main"
              v-if="score.displayType == 'dataClean'"
            >
              <div class="customizePlan-result-main-title flex_center_start">
                <img
                  src="@/assets/images/dataServices/customizePlan/datacleaning-icon.png"
                  alt=""
                />
                <span @click="toExperience(score.displayType)"
                  >Data Cleaning Services</span
                >
              </div>
              <div class="customizePlan-result-main-desc">
                Clean, verify, and enrich corporate data at scale. Turn
                fragmented lists into actionable intelligence.
              </div>
            </div>
            <div
              class="customizePlan-result-main"
              v-if="score.displayType == 'api'"
            >
              <div class="customizePlan-result-main-title flex_center_start">
                <img
                  src="@/assets/images/dataServices/customizePlan/dataapi-icon.png"
                  alt=""
                />
                <span @click="toExperience(score.displayType)"
                  >Data API Services</span
                >
              </div>
              <ul class="customizePlan-result-main-tags">
                <li>Registration Information</li>
                <li>Financial Ratios</li>
                <li>Judicial Data</li>
                <li>News and Public Opinion</li>
              </ul>
              <div class="customizePlan-result-main-desc">
                Access and enrich comprehensive company data in one API call. A
                developer‑friendly, high‑performance solution for seamless
                integration.
              </div>
            </div>
            <div
              class="customizePlan-result-main"
              v-if="score.displayType == 'bulkData'"
            >
              <div class="customizePlan-result-main-title flex_center_start">
                <img
                  src="@/assets/images/dataServices/customizePlan/bulkdata-icon.png"
                  alt=""
                />
                <span @click="toExperience(score.displayType)"
                  >Bulk Data Service</span
                >
              </div>
              <div class="customizePlan-result-main-desc">
                Build your own dataset. Select fields on-demand and receive
                ready-to-use, structured data.
              </div>
            </div>
            <!-- btn -->
            <el-button
              class="cp-experience-btn"
              @click="toExperience(score.displayType)"
            >
              <img
                src="@/assets/images/dataServices/customizePlan/star.png"
                alt=""
              />
              <span class="span">Experience Now</span>
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 免责 -->
    <el-dialog
      class="dialog_modal"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="643px"
    >
      <div class="customizePlan-questions-page intelligence">
        <div class="customizePlan-title">Tailoring Your Data Intelligence</div>
        <div class="customizePlan-questions-intelligence">
          <p>
            To find the perfect data plan for you, we'd love to learn a bit
            about your needs. A few brief questions allow us to precisely
            identify your needs for business information and your preferred
            access method. This enables us to recommend an optimal data
            plan—whether you require real-time API integration, bulk custom
            datasets, or managed cleansing services.
          </p>
          <p>
            Our solutions are built with flexibility, wide coverage, and depth
            of data at their core, ensuring they adapt seamlessly to your
            operations. From multinational corporations to growth-stage
            companies, we deliver the right intelligence, in the right format,
            to drive your strategic decisions.
          </p>
          <p>
            Just so you know: Your answers are just for us to understand what
            you're looking for. They're completely confidential, and we won't
            store or access them for anything else.
          </p>
        </div>
      </div>
      <div class="customizePlan-questions-footer intelligence flex_center">
        <el-button
          type="primary"
          class="customizePlan-questions-btn"
          @click="dialogVisible = false"
          key="begin"
          >Let's Begin</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Header from "../../layout/header.vue";
import { getCustomizePlanQA, getCustomizeScore } from "@/api/dataServicesApi";
export default {
  components: {
    Header,
  },
  data() {
    return {
      allQuestions: [],
      currentPage: 1,
      pageSize: 3,
      answers: {}, // 存储用户答案：{ [questionId]: answer }
      // 用于 el-select 的 v-model 映射（因为 el-select 需要一个值，不能直接绑对象）
      selectedValueMap: {},
      input11: "",
      value11: "",
      value12: "",
      options: [
        {
          value: "North America",
          label: "North America",
        },
        {
          value: "South America",
          label: "South America",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
        {
          value: "选项6",
          label: "北京烤鸭1",
        },
        {
          value: "选项7",
          label: "北京烤鸭3",
        },
      ],
      value21: "",
      value22: "",
      value23: "",
      value31: "",
      value32: "",
      value33: "",
      value41: "",
      textarea41: "",
      resultShow: 0,
      resultShowData: [
        {
          displayType: "api",
        },
        {
          displayType: "bulkData",
        },
        {
          displayType: "dataClean",
        },
      ],
      dialogVisible: true,
    };
  },
  computed: {
    // // 判断当前页是否填满（用于按钮状态）
    // isNextDisabled() {
    //   if(
    //     (this.currentPage == 1 && this.input11 && this.value11 && this.value12)
    //   ||(this.currentPage == 2 && this.value21 && this.value22 && this.value23)
    //   ||(this.currentPage == 3 && this.value31 && this.value32 && this.value33)
    //   ||(this.currentPage == 4 && this.value41 && this.textarea41)
    //   ){
    //     return false;
    //   }
    //   return true;
    // },
    // 总页数
    totalPages() {
      return Math.ceil(this.allQuestions.length / this.pageSize);
    },
    // 当前页的问题
    currentQuestions() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.allQuestions.slice(start, end);
    },
    // ✅ 核心：当前页是否全部填写完成
    isCurrentPageValid() {
      console.log(
        "isCurrentPageValid",
        this.currentQuestions.every((item) => this.validateItem(item)),
      );
      return this.currentQuestions.every((item) => this.validateItem(item));
    },
  },
  mounted() {
    // 主题色
    this.$store.dispatch("app/setThemColor", "#B98B73");
    this.$store.dispatch("app/setSearchType", "dataServices");
    this.getCustomizePlanQAFn();
  },
  methods: {
    validateItem(item) {
      // ✅ 新增：otherDemand == 1 表示非必填，跳过校验
      if (item.customizePlanQuestion.otherDemand == 1) {
        return true;
      }
      if (item.customizePlanQuestion.keyMatch == 1) {
        return !!(
          item.customizePlanQuestion.customerInput &&
          item.customizePlanQuestion.customerInput.trim()
        );
      } else {
        return item.customizePlanAnswers.some((opt) => opt.selected === 1);
      }
    },
    // ✅ 全局校验：所有必填题是否都已填写
    isAllPagesValid() {
      const invalidItem = this.allQuestions.find(
        (item) => !this.validateItem(item),
      );
      if (invalidItem) {
        // 可选：自动跳转到该问题所在页（提升体验）
        const index = this.allQuestions.indexOf(invalidItem);
        const pageNum = Math.floor(index / this.pageSize) + 1;
        this.currentPage = pageNum;

        // 提示用户
        this.$message.warning(
          `请完成“${invalidItem.customizePlanQuestion.questionEn}”`,
        );
        return false;
      }
      return true;
    },
    async getCustomizePlanQAFn() {
      await getCustomizePlanQA().then((res) => {
        console.log("获取问卷", JSON.parse(JSON.stringify(res)));
        if (res.code == 200) {
          this.allQuestions = res.data;
          this.initSelectedValues();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    initSelectedValues() {
      const map = {};
      this.allQuestions.forEach((item) => {
        const { keyMatch, otherDemand, questionEn } =
          item.customizePlanQuestion;
        if (keyMatch !== 1 && otherDemand !== 1) {
          const selectedAnswers = item.customizePlanAnswers
            .filter((opt) => opt.selected === 1)
            .map((opt) => opt.answerEn);
          console.log(
            "selectedAnswers",
            JSON.parse(JSON.stringify(selectedAnswers)),
          );
          if (this.isMultiple(item)) {
            map[questionEn] = selectedAnswers; // 数组
          } else {
            map[questionEn] = selectedAnswers[0] || ""; // 字符串
          }
        }
      });
      console.log("selectedValueMap", JSON.parse(JSON.stringify(map)));
      this.selectedValueMap = map;
    },
    // 判断是否多选
    isMultiple(item) {
      return (
        !item.customizePlanQuestion.oneSelect ||
        item.customizePlanQuestion.oneSelect > 1
      );
    },
    handleSelectChange(item, newValue) {
      console.log("选中的项", JSON.parse(JSON.stringify(item)));
      console.log("选中的项", newValue);
      // 先重置所有选项为未选中
      item.customizePlanAnswers.forEach((opt) => {
        opt.selected = 0;
      });

      if (this.isMultiple(item)) {
        // 多选：newValue 是数组
        if (Array.isArray(newValue)) {
          newValue.forEach((val) => {
            const target = item.customizePlanAnswers.find(
              (opt) => opt.answerEn === val,
            );
            if (target) target.selected = 1;
          });
        }
      } else {
        // 单选：newValue 是字符串
        if (newValue) {
          const target = item.customizePlanAnswers.find(
            (opt) => opt.answerEn === newValue,
          );
          if (target) target.selected = 1;
        }
      }
    },
    // 跳转到指定页
    goToPage(page) {
      if (!this.isCurrentPageValid) {
        return;
      }
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
      // else{
      //   this.resultShow = 1;
      // }
    },
    submit() {
      console.log("提交数据:", JSON.parse(JSON.stringify(this.allQuestions)));
      // this.$message.success('问卷已提交！');
      // if (!this.isAllPagesValid()) {
      //   console.log('校验失败，不提交');
      //   return; // 校验失败，不提交
      // }
      this.getCustomizeScoreFn();
    },
    async getCustomizeScoreFn() {
      await getCustomizeScore(this.allQuestions).then((res) => {
        console.log("获取问卷结果", JSON.parse(JSON.stringify(res)));
        if (res.code == 200) {
          this.resultShow = 1;
          this.resultShowData = res.data.sort(
            (a, b) => Number(a.sortId) - Number(b.sortId),
          );
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    toExperience(type) {
      let path = "";
      if (type == "api") {
        path = "/dataServices/dataApi";
      } else if (type == "bulkData") {
        path = "/dataServices/bulkData";
      } else if (type == "dataClean") {
        path = "/dataServices/dataCleaning";
      }
      this.$router.push({ path: path });
    },
  },
};
</script>
<style scoped>
.customizePlan-container {
  overflow-y: auto;
  display: flex;
  justify-content: center;
}
.customizePlan-content {
  /* width: 700px; */
  margin: 20px 0;
}
.customizePlan-content::after{
  content: '';
  display: block;
  width: 100%;
  height: 50px;
}
.customizePlan-title {
  width: 700px;
  height: 30px;
  font-weight: bold;
  font-size: 24px;
  color: #1a2332;
  line-height: 30px;
  text-align: left;
  margin-bottom: 14px;
}
.customizePlan-subtitle {
  width: 700px;
  height: 22px;
  /* font-family: ArialMT; */
  font-size: 18px;
  color: #666666;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  margin-bottom: 30px;
  white-space: nowrap;
}
.customizePlan-questions {
  width: 700px;
  /* height: 836px; */
  min-height: calc(100vh - 220px);
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 30px;
  padding: 30px 40px 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.questions-steps-ul {
  gap: 8px;
}
.questions-steps-ul > li {
  width: 60px;
  height: 6px;
  background: #dddddd;
  border-radius: 5px;
  cursor: pointer;
}
.questions-steps-ul > li.current {
  background: #b98b73;
}
.customizePlan-questions-body {
  flex: 1;
  padding: 30px 0;
}
.customizePlan-questions-btn {
  width: 220px;
  height: 50px;
  background: #b98b73;
}
.customizePlan-content .customizePlan-questions-btn.is-disabled {
  background: #eeeeee;
  color: #999999;
}
.customizePlan-questions-item {
  margin-bottom: 30px;
}
.customizePlan-questions-item-label {
  font-weight: bold;
  font-size: 22px;
  color: #1a2332;
  line-height: 38px;
  text-align: left;
  font-style: normal;
  margin-bottom: 20px;
}
.customizePlan-questions-item-value .el-input,
.customizePlan-questions-item-value .el-select,
.customizePlan-questions-item-value .el-textarea {
  width: 100%;
}
.customizePlan-questions-item-value /deep/ .el-input__inner {
  padding-left: 14px;
  padding-right: 40px;
  font-size: 20px;
}
.customizePlan-questions-item-value /deep/ .el-textarea__inner {
  padding-left: 14px;
  padding-right: 14px;
  font-size: 20px;
  height: 260px;
}
.customizePlan-questions-item-value /deep/ .el-input__inner::placeholder,
.customizePlan-questions-item-value /deep/ .el-textarea__inner::placeholder {
  color: #999999;
  font-size: 20px;
}
.customizePlan-questions-item-value /deep/ .el-input .el-input__clear,
.customizePlan-questions-item-value /deep/ .el-select .el-select__caret {
  font-size: 24px;
  color: #1a2332;
}
.customizePlan-questions-item-value
  /deep/
  .el-input
  .el-input__clear.el-input__clear,
.customizePlan-questions-item-value
  /deep/
  .el-select
  .el-select__caret.el-icon-circle-close {
  color: #c0c4cc;
}

.customizePlan-questions-item-value /deep/ .el-input__suffix {
  right: 10px;
}
/* 多选样式 */
.customizePlan-questions-item-value /deep/ .el-select .el-select__tags {
  padding: 0 14px;
}
.customizePlan-questions-item-value /deep/ .el-select .el-tag {
  margin: 3px 6px 3px 0;
}
.customizePlan-questions-item-value /deep/ .el-select .el-tag.el-tag--info {
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid #cccccc;
  padding: 0 10px;
  height: 40px;
  font-family: ArialMT;
  font-size: 18px;
  color: #1a2332;
}
.customizePlan-questions-item-value /deep/ .el-select .el-tag .el-icon-close {
  width: 22px;
  height: 22px;
  background: #ff4646;
  color: #fff;
  line-height: 22px;
  font-size: 20px;
}
/* 结果 */
.customizePlan-content.result {
  width: 547px;
}
.customizePlan-result-card-list {
  border-bottom: 1px solid transparent;
}
.customizePlan-result-card {
  width: 547px; /* 背景图有阴影，总差 28px，一边 14px; 547px; */
  height: auto;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgb(0 0 0 / 12%);
  border-radius: 30px;
  padding: 40px 46px 40px;
  margin-bottom: 50px;
}
.customizePlan-result-card:last-of-type{
  margin-bottom: 0;
}
.customizePlan-result-main {
  width: 100%;
  /* background: rgba(255,254,253,0.25); */
  /* border-radius: 30px; */
  /* border: 1px solid #FFFCFC; */
  /* padding: 24px; */
}
.customizePlan-result-main-title {
  font-weight: bold;
  font-size: 22px;
  color: #1a2332;
  text-align: left;
  font-style: normal;
  margin-bottom: 20px;
  text-decoration: underline;
  text-decoration-color: #9b9ea5;
  gap: 0 21px;
  cursor: pointer;
}
.customizePlan-result-main-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.customizePlan-result-main-tags > li {
  background: #faf1ec;
  border-radius: 6px;
  font-weight: 400;
  font-size: 16px;
  color: #b98b73;
  font-style: normal;
  padding: 5px 10px;
}
.customizePlan-result-main-desc {
  font-weight: 400;
  font-size: 18px;
  color: #666;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  margin: 12px 0 30px;
}
.cp-experience-btn {
  width: 100%;
  height: 46px;
  background: #faf1ec;
  border-radius: 4px;
}
.cp-experience-btn img {
  vertical-align: middle;
}
.cp-experience-btn .span {
  font-size: 16px;
  color: #b98b73;
  margin-left: 6px;
}
.cp-experience-btn:hover {
  background: linear-gradient(90deg, #ffeed1 0%, #f4b150 100%);
}
.customizePlan-questions-page.intelligence {
  padding: 0 9px;
  overflow: auto;
}
.customizePlan-questions-page.intelligence .customizePlan-title {
  text-align: center;
  width: auto;
  margin: 24px 0 0px;
}
.customizePlan-questions-intelligence {
  font-size: 18px;
  color: #1a2332;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  margin-top: 30px;
}
.customizePlan-questions-intelligence > p {
  margin-bottom: 30px;
  word-break: break-word;
}
.customizePlan-questions-footer.intelligence {
  margin: 16px 0 16px;
}
@media (max-width: 1920px) {
  /* 标题字体 20px */
  .customizePlan-content .customizePlan-title,
  .customizePlan-questions-item-label,
  .customizePlan-result-main-title
  {
    font-size: 20px !important;
  }
  /* 文本字体 16px */
  .customizePlan-subtitle,
  .customizePlan-questions-item-value /deep/ .el-input__inner,
  .customizePlan-questions-item-value /deep/ .el-textarea__inner,
  .customizePlan-questions-item-value /deep/ .el-input__inner::placeholder,
  .customizePlan-questions-item-value /deep/ .el-textarea__inner::placeholder,
  .customizePlan-questions-item-value /deep/ .el-select .el-tag.el-tag--info,
  .customizePlan-content .customizePlan-questions-btn,
  .customizePlan-result-main-desc,
  .customizePlan-result-main-tags > li,
  .cp-experience-btn .span
  {
    font-size: 16px !important;
  }
  .customizePlan-questions-item-value /deep/ .el-input .el-input__clear,
  .customizePlan-questions-item-value /deep/ .el-select .el-select__caret
  {
    font-size: 22px;
  }
  .customizePlan-questions-item-value /deep/ .el-select .el-tag .el-icon-close{
    font-size: 15px;
    width: 20px;
    height: 20px;
    line-height: 20px;
  }
  /* 圆角 */
  .customizePlan-questions{
    border-radius: 10px;
    padding: 22px 30px 30px;
  }
  .customizePlan-result-card{
    border-radius: 10px;
    padding: 30px 34px 30px;
    margin-bottom: 37px;
  }
  /* padding + margin  */
  .customizePlan-content .customizePlan-title{
    margin-bottom: 10px;
  }
  .customizePlan-subtitle{
    margin-bottom: 22px;
  }
  .customizePlan-questions-item-label{
    margin-bottom: 15px;
  }
  .customizePlan-questions-item{
    margin-bottom: 22px;
  }
  .customizePlan-result-main-title{
    margin-bottom: 15px;
  }
  .customizePlan-result-main-desc{
    margin: 9px 0 22px;
  }
  /* 其他 */
  .customizePlan-questions-item-value /deep/ .el-select .el-tag.el-tag--info{
    height: 30px;
  }
}
@media (max-width: 1440px) {
  /* 标题字体 18px */
  .customizePlan-content .customizePlan-title,
  .customizePlan-questions-item-label,
  .customizePlan-result-main-title
  {
    font-size: 18px !important;
  }
  /* 文本字体 14px */
  .customizePlan-subtitle,
  .customizePlan-questions-item-value /deep/ .el-input__inner,
  .customizePlan-questions-item-value /deep/ .el-textarea__inner,
  .customizePlan-questions-item-value /deep/ .el-input__inner::placeholder,
  .customizePlan-questions-item-value /deep/ .el-textarea__inner::placeholder,
  .customizePlan-questions-item-value /deep/ .el-select .el-tag.el-tag--info,
  .customizePlan-content .customizePlan-questions-btn,
  .customizePlan-result-main-desc,
  .customizePlan-result-main-tags > li,
  .cp-experience-btn .span
  {
    font-size: 14px !important;
  }
  .customizePlan-questions-item-value /deep/ .el-input .el-input__clear,
  .customizePlan-questions-item-value /deep/ .el-select .el-select__caret{
    font-size: 20px;
  }
  .customizePlan-questions-item-value /deep/ .el-select .el-tag .el-icon-close{
    font-size: 13px;
    width: 18px;
    height: 18px;
    line-height: 18px;
  }
  /* 圆角 */
  .customizePlan-questions{
    border-radius: 8px;
    padding: 20px 26px 26px;
  }
  .customizePlan-result-card{
    border-radius: 8px;
    padding: 26px 30px 26px;
    margin-bottom: 33px;
  }
  /* padding + margin  */
  .customizePlan-content .customizePlan-title{
    margin-bottom: 9px;
  }
  .customizePlan-subtitle{
    margin-bottom: 20px;
  }
  .customizePlan-questions-item-label{
    margin-bottom: 13px;
  }
  .customizePlan-questions-item{
    margin-bottom: 20px;
  }
  .customizePlan-result-main-title{
    margin-bottom: 13px;
  }
  .customizePlan-result-main-desc{
    margin: 8px 0 20px;
  }
  /* 其他 */
  .customizePlan-questions-item-value /deep/ .el-select .el-tag.el-tag--info{
    height: 26px;
  }
}
/* @media (max-width: 1279px) {
  .customizePlan-title {
    font-size: 20px;
  }
  .customizePlan-questions-intelligence {
    font-size: 16px;
    line-height: 26px;
  }
  .customizePlan-questions-item-label {
    font-size: 18px;
  }
  .customizePlan-questions-item-value /deep/ .el-textarea__inner,
  .customizePlan-questions-item-value /deep/ .el-input__inner::placeholder,
  .customizePlan-questions-item-value /deep/ .el-textarea__inner::placeholder {
    font-size: 16px;
  }
  .customizePlan-questions-btn {
    width: 200px;
    height: 40px;
    font-size: 16px;
  }
} */
</style>
